var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg2RolesPermissions(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 30,
    viewBox: "0 0 46 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2128_55)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.5818 12.6873H34.1564C33.4816 12.6873 32.9346 13.2343 32.9346 13.9091V19.9854C32.9346 20.6602 33.4816 21.2073 34.1564 21.2073H43.5818C44.2566 21.2073 44.8037 20.6602 44.8037 19.9854V13.9091C44.8037 13.2343 44.2566 12.6873 43.5818 12.6873Z",
    stroke: "#76808D",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.4363 12.3818V10.0145C42.4363 8.03999 40.8436 6.44727 38.869 6.44727C36.8945 6.44727 35.3018 8.03999 35.3018 10.0145V12.5345",
    stroke: "#76808D",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.8691 17.7273V19.56",
    stroke: "#76808D",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.8691 17.0291C39.4655 17.0291 39.9491 16.5455 39.9491 15.9491C39.9491 15.3526 39.4655 14.8691 38.8691 14.8691C38.2726 14.8691 37.7891 15.3526 37.7891 15.9491C37.7891 16.5455 38.2726 17.0291 38.8691 17.0291Z",
    stroke: "#76808D",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.455 15C23.455 8.67382 18.3266 3.54544 12.0004 3.54544C5.67427 3.54544 0.545898 8.67382 0.545898 15C0.545898 21.3262 5.67427 26.4545 12.0004 26.4545C18.3266 26.4545 23.455 21.3262 23.455 15Z",
    stroke: "#76808D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9742 3.6218C14.3997 3.57817 14.836 3.54544 15.2724 3.54544C15.7633 3.54544 16.2542 3.57817 16.7342 3.63271C22.3742 4.35271 26.7269 9.16362 26.7269 15C26.7269 20.8364 22.3633 25.6473 16.7233 26.3673C16.2433 26.4218 15.7633 26.4545 15.2724 26.4545C14.7597 26.4545 14.2469 26.4218 13.7451 26.3564",
    stroke: "#76808D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.942 3.6218C17.3674 3.57817 17.8038 3.54544 18.2402 3.54544C18.7311 3.54544 19.222 3.57817 19.702 3.63271C25.342 4.35271 29.6947 9.16362 29.6947 15C29.6947 20.8364 25.3311 25.6473 19.6911 26.3673C19.2111 26.4218 18.7311 26.4545 18.2402 26.4545C17.7274 26.4545 17.2147 26.4218 16.7129 26.3564",
    stroke: "#76808D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.109 17.0946C14.1032 17.0946 15.7199 15.4779 15.7199 13.4837C15.7199 11.4894 14.1032 9.87274 12.109 9.87274C10.1147 9.87274 8.49805 11.4894 8.49805 13.4837C8.49805 15.4779 10.1147 17.0946 12.109 17.0946Z",
    stroke: "#76808D",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.909 24.9382C16.909 22.2327 14.7163 20.0291 11.9999 20.0291C9.28355 20.0291 7.09082 22.2218 7.09082 24.9382",
    stroke: "#76808D",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2128_55"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 45.3491,
    height: 24,
    fill: "white",
    transform: "translate(0 3)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg2RolesPermissions);
export default __webpack_public_path__ + "static/media/2-roles-permissions.bc20ece6c207f66c4e74a71b95589562.svg";
export { ForwardRef as ReactComponent };